// extracted by mini-css-extract-plugin
export default {"root":"root__v2fT0","storeName":"storeName__iz5B-","dmHeadingTitle":"dmHeadingTitle__GDfJk","closeButton":"closeButton__qWobH"};